import {View} from 'react-native'
import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'
import {Trans} from '@lingui/react/macro'

import {HELP_DESK_URL} from '#/lib/constants'
import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {atoms as a} from '#/alf'
import * as Layout from '#/components/Layout'
import {InlineLinkText} from '#/components/Link'
import {P, Text} from '#/components/Typography'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'Support'>
export const SupportScreen = (_props: Props) => {
  const {_} = useLingui()

  return (
    <Layout.Screen>
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          <Layout.Header.TitleText>
            <Trans>Support</Trans>
          </Layout.Header.TitleText>
        </Layout.Header.Content>
        <Layout.Header.Slot />
      </Layout.Header.Outer>
      <Layout.Content>
        <View style={[a.px_xl, a.py_lg, a.gap_lg]}>
          <Text style={[a.text_2xl, a.font_bold]}>
            <Trans>Support</Trans>
          </Text>

          <P>
            <Trans>
              Need help? Visit{' '}
              <InlineLinkText to={HELP_DESK_URL} label={HELP_DESK_URL}>
                {HELP_DESK_URL}
              </InlineLinkText>{' '}
              to get in touch with us.
            </Trans>
          </P>

          <View style={[a.gap_sm, a.pt_sm]}>
            <Text style={[a.text_lg, a.font_bold]}>
              <Trans>Policies</Trans>
            </Text>
            <InlineLinkText to="/support/privacy" label={_(msg`Privacy Policy`)}>
              <Trans>Privacy Policy</Trans>
            </InlineLinkText>
            <InlineLinkText to="/support/tos" label={_(msg`Terms of Service`)}>
              <Trans>Terms of Service</Trans>
            </InlineLinkText>
            <InlineLinkText
              to="/support/community-guidelines"
              label={_(msg`Community Guidelines`)}>
              <Trans>Community Guidelines</Trans>
            </InlineLinkText>
            <InlineLinkText
              to="/support/copyright"
              label={_(msg`Copyright Policy`)}>
              <Trans>Copyright Policy</Trans>
            </InlineLinkText>
            <InlineLinkText
              to="/support/2257"
              label={_(msg`2257 Disclosure`)}>
              <Trans>2257 Disclosure</Trans>
            </InlineLinkText>
            <InlineLinkText
              to="/support/network-services-privacy"
              label={_(msg`Network Services Privacy Policy`)}>
              <Trans>Network Services Privacy Policy</Trans>
            </InlineLinkText>
          </View>
        </View>
      </Layout.Content>
    </Layout.Screen>
  )
}
